<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { propertyService } from "../../../services/propertyservice/property.service";
import { projectService } from "../../../services/projectservice/project.service";
import { bookingService } from "../../../services/bookingservice/booking.service";
import { saleService } from "../../../services/saleservice/sale.service";
import { servicehelpers } from "../../../services/servicehelpers";
import { propertycancelationService } from "../../../services/propertyservice/propertycancelation.service";
import List from "../../../components/list";
import Screen from "../../../components/screen";
import Fastview from "@/components/property-fastview";
import i18n from "../../../i18n";
/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  extends: Screen,
  page: {
    title: "Properties List",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    List, 
    Fastview,
  },
  data() {
    return {
      ...Screen.Alert,
      ...Screen.Locate,
      propertyData: {},
      typeData: {},
      projectData: {},
      statusData: {},
      mergeData: {},
      cancelationData: {},
      fetchingStats: false,
      title: "Properties List",

      viewTitle: '',
      viewObject: null,

      valueMergeProperty: (this.$route.path == '/additional/property-master')

    };
  },
  mounted() {

    // this.valueMergeProperty = (this.$route.path == '/additional/property-master');
    
    // this.loadingpropertyTypeData();
    // this.loadingData(`?clause={"clause":[{"conjuction":"and","property_cancelations.property_cancelation_status_id":{"value":1}}]}`);
    this.loadingData();
    this.loadingprojectData();
    this.loadingpropertyStatusData();

  },

  methods: {
    loadingData: function(param = '') {

    //param = `?clause={"clause":[{"conjuction":"and","property_cancelations.property_cancelation_status_id":{"value":1}}]}`;

    this.fetchingStats = false;
    propertycancelationService.getList(param)
        .then(response => {
          
          this.fetchingStats = true;
          this.cancelationData = response;
        });
    },

    loadingpropertyStatusData: function() {
      servicehelpers.getPropertyCancelationStatusData().then(response => {
        this.statusData = response;
      });
    },

    loadingprojectData: function() {
      projectService.getList()
        .then(response => {
          this.projectData = response;

          // console.log(JSON.stringify(this.projectData.data));
        });
    },

    deleted: function(id) {

      let obj = this.propertyData.data.find(item => item.id === id);

      console.log(obj.property_status_id);

      if(obj.property_status_id == 3) {
        saleService.removeByProperty(id)
        .then(response => {
        
          // this.saleData = response;
          if(response.status == 200) {
            this.$swal.fire({
              title: i18n.t('general.confirm.deleted'),
              text: i18n.t('general.confirm.success'),
              icon: "success",
              confirmButtonText: i18n.t('general.ok')
            });
          }
        });
      } else if(obj.property_status_id == 2) {
        bookingService.removeByProperty(id)
        .then(response => {
        
          // this.bookingData = response;
          if(response.status == 200) {
            this.$swal.fire({
              title: i18n.t('general.confirm.deleted'),
              text: i18n.t('general.confirm.success'),
              icon: "success",
              confirmButtonText: i18n.t('general.ok')
            });
          }
        });
      } else {
        propertyService.remove(id)
        .then(response => {
          if(response.status == 200) {
            this.$swal.fire({
              title: i18n.t('general.confirm.deleted'),
              text: i18n.t('general.confirm.success'),
              icon: "success",
              confirmButtonText: i18n.t('general.ok')
            });
          }
        });
      }
    },

    pageNavigate: function(param) {

      this.loadingData(param);
    },

    submitAdd: function() {
      this.$router.push(this.$route.query.redirectFrom || {
              name: "property-add",
          });
    },
    projectChanged: function(event) {
      console.log("change::out ", event);
      // this.loadingpropertyFloorData(event);
      // this.loadingpropertyGroupData(event);
      // this.floorData.data = [];
      // this.project = event;
      // this.loadingPropertyData(this.project);

      this.mergeData = [{id: 1, label: i18n.t('property.merge.text')}];
    },
    moreCancelClicked: function(event, id) {
      if(event == 'approve') {
        this.$swal.fire({
          title: i18n.t('general.cancel-confirm.title'),
          text: i18n.t('property.cancelation.approve'),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#f46a6a",
          confirmButtonText: i18n.t('general.ok'),
          cancelButtonText: i18n.t('general.cancel')
        }).then(result => {
          if (result.value) {
                
            propertycancelationService.approve(id).then(response => {
              if(response.status == 200) {
                
                // this.loadingData(`?clause={"clause":[{"conjuction":"and","property_cancelations.property_cancelation_status_id":{"value":1}}]}`);
                this.loadingData();
                this.$swal.fire({
                  title: i18n.t('general.success.title'),
                  text: i18n.t('general.success.message'),
                  icon: "success",
                  confirmButtonColor: "#34c38f",
                  confirmButtonText: i18n.t('general.success.yes')
                });

              }
            });

          }
        });
      } else {
        this.$swal.fire({
          title: i18n.t('general.cancel-confirm.title'),
          text: i18n.t('property.cancelation.denie'),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#f46a6a",
          confirmButtonText: i18n.t('general.ok'),
          cancelButtonText: i18n.t('general.cancel')
        }).then(result => {
          if (result.value) {

            propertycancelationService.denie(id).then(response => {
              if(response.status == 200) {
                
                // this.loadingData(`?clause={"clause":[{"conjuction":"and","property_cancelations.property_cancelation_status_id":{"value":1}}]}`);
                this.loadingData();
                this.$swal.fire({
                  title: i18n.t('general.success.title'),
                  text: i18n.t('general.success.message'),
                  icon: "success",
                  confirmButtonColor: "#34c38f",
                  confirmButtonText: i18n.t('general.success.yes')
                });

              }
            });

          }
        });
      }
    },
  
  }
};
</script>

<template>
  <Layout>
    <PageHeader :add="null"
    :title="$t('menuitems.cancelation.text')" />
    <Fastview 
      id="fast-view"
      ref="fast-view"
      :title="viewTitle"
      :item="viewObject"
      :filters="$options.filters"
    /> 
    <List v-bind:dataList="cancelationData" 
                    v-bind:updating="fetchingStats" 
        v-bind:navigate="pageNavigate"
        v-bind:formats="[{name: 'total', type: 'currency', sign: '$'}, {name: 'refund_amount', type: 'currency', sign: '$'}, 
        {name: 'status', color: true}, {name: 'for_date', type: 'date'}]"
        v-bind:fields="[ `for_date: ${$t('property.cancelation.date')}`,
        `property: ${$t('property.text')}`, `booking: ${$t('property.cancelation.booking')}`, 
          `sale: ${$t('property.cancelation.sale')}`, `status: ${$t('property.status')}`, 
          `total: ${$t('property.cancelation.total')}`, `refund_amount: ${$t('property.cancelation.refund')}`,
          `notation: ${$t('property.cancelation.notation')}`
        ]" 
        @more="moreCancelClicked"
        v-bind:more="{
          sub: [{
            name: 'property.cancelation.approve', icon: 'bx bx-check-circle', action: 'approve', link: 'commission-paid', column: 'id', show: {column: 'property_cancelation_status_id', value: 1}
          },{
            name: 'property.cancelation.denie', icon: 'bx bx-x-circle', action: 'denie', link: 'commission-paid', column: 'id', show: {column: 'property_cancelation_status_id', value: 1}
          },{
            name: 'property.contract', icon: 'bx bx-file', link: 'property-cancellation-contract', column: 'id', target: '_blank' //show: {column: 'property_cancelation_status_id', value: 1}, 
          }] 
        }"
        
        v-bind:filter="{
          search: ['properties.code', 'properties.description'], 
          dropdown: [{
              title: 'property.project',
              field: 'properties.project_id',
              data: this.projectData.data,
              method: (event) => projectChanged(event),
              default: 1,
              width: 2
            }, {
              title: 'property.status',
              field: 'property_cancelations.property_cancelation_status_id',
              data: this.statusData.data,
              width: 2
            }
          ], 
          date: {
            title: 'general.date',
            field: 'property_cancelations.for_date'
          }
        }"
    />  
  </Layout>
</template>